<!-- Hero Section -->
<section class="relative flex flex-col items-center gap-6">
  <div
    class="absolute h-full w-full bg-[radial-gradient(#d1d5db_1px,transparent_1px)] [background-size:16px_16px] [mask-image:radial-gradient(ellipse_50%_50%_at_50%_50%,#000_85%,transparent_100%)]"
  ></div>
  <div class="z-10 flex flex-col items-center gap-14">
    <h1 class="text-center text-4xl font-bold leading-relaxed md:text-5xl">
      @defer {
        Partner with
        <span
          [roughNotation]="{
            animate: true,
            animationDelay: 500,
            strokeWidth: 3,
            iterations: 4,
            type: 'underline',
            color: 'var(--tui-background-accent-2)',
            padding: 2,
          }"
          >OpenForge</span
        ><br />for Expert Capacitor Development
      } @placeholder {
        Partner with OpenForge<br />for Expert Capacitor Development
      }
    </h1>
    <p class="w-full text-balance text-center text-xl leading-snug md:w-3/4">
      <span class="hidden md:block"
        >OpenForge is a trusted partner of Capawesome, providing expert mobile
        app development services with deep knowledge of all Capawesome plugins
        and Capawesome Cloud for enterprise implementations</span
      >
      <span class="md:hidden"
        >OpenForge is a trusted Capawesome partner providing expert mobile app
        development with deep plugin knowledge</span
      >
    </p>
    <div class="flex flex-col space-y-4 sm:flex-row sm:space-x-4 sm:space-y-0">
      <a
        iconEnd="@tui.external-link"
        size="l"
        tuiButton
        type="button"
        [href]="openForgeWebsite"
        target="_blank"
        data-umami-event="partners-openforge-visit-website"
      >
        Visit OpenForge
      </a>
      <a
        appearance="secondary"
        size="l"
        tuiButton
        type="button"
        [href]="'mailto:' + emailOpenforge"
        data-umami-event="partners-openforge-contact"
      >
        Schedule a Call
      </a>
    </div>
  </div>
</section>
